import { ColorHues } from "@chakra-ui/react";

/**
 * Generated via https://lyft-colorbox.herokuapp.com/
 */
export const PrimaryColors: ColorHues = {
    50: "#95C7FF",
    100: "#65A5FD",
    200: "#3884F9",
    300: "#1165F2",
    400: "#004EE9",
    500: "#0044DD",
    600: "#003DCB",
    700: "#0034B8",
    800: "#002CA0",
    900: "#002387",
};


export const PrimaryDarkColors: ColorHues = {
    50: "#E5EAF5",
    100: "#D0D8F0",
    200: "#BBC5EC",
    300: "#929DCB",
    400: "#4A5570",
    500: "#565F80",
    600: "#343C50",
    700: "#1A1F2A",
    800: "#0E1013",
    900: "#07090A",
};

